var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import { SitesClient, GetSiteListPaginatedQuery, PaginatedEnumerableOfSiteModel, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { HttpHelper } from "@/app/utils/http-helper";
import RouteNames from "@/app/router/routes";
const siteClient = new SitesClient(window.apiUrl);
let CompanySitesVue = class CompanySitesVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.searchAttempted = false;
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "SiteName",
            direction: SortDirection.Ascending
        }));
        // models
        this.query = new GetSiteListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            includeDeleted: false,
            companyId: this.companyId,
            sort: this.sorter.currentSort
        });
        this.data = new PaginatedEnumerableOfSiteModel();
    }
    created() {
        this.search();
    }
    ;
    // get
    search() {
        if (!this.canSearch)
            return;
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        siteClient
            .getListPaginated(this.query)
            .then(response => {
            this.data = new PaginatedEnumerableOfSiteModel();
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        this.search();
    }
    ;
    // set
    edit(site) {
        this.$router.push({ name: RouteNames.Site, params: { id: site.siteId.toString() } });
    }
    ;
    downloadConnectionProfile(site) {
        if (!site || !site.siteId)
            return;
        siteClient
            .getConnectionProfile(site.siteId)
            .then(response => {
            if (!response || !response.data)
                return;
            const fileName = response.fileName || "AssureConnectionProfile.cfg";
            const objectUrl = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(objectUrl);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    archive(site) {
        if (this.working)
            return;
        siteClient
            .getArchiveImpact(site.siteId)
            .then((impact) => {
            const parts = [];
            if (impact.systemsCount > 0) {
                parts.push(`${impact.systemsCount} system${impact.systemsCount === 1 ? '' : 's'}`);
            }
            let msg;
            if (parts.length > 0) {
                let subjects = '';
                if (parts.length === 1) {
                    subjects = parts[0];
                }
                else if (parts.length === 2) {
                    subjects = `${parts[0]} and ${parts[1]}`;
                }
                else {
                    subjects = `${parts.slice(0, -1).join(', ')}, and ${parts[parts.length - 1]}`;
                }
                msg = `Archiving this site will also archive ${subjects}. Are you sure you want to continue?`;
            }
            else {
                msg = "Are you sure that you want to archive this site?";
            }
            this.$confirmModal.show(msg, { title: "Please confirm" })
                .then((value) => {
                if (!value)
                    return;
                this.performArchive(site);
            });
        });
    }
    performArchive(site) {
        this.working = true;
        siteClient
            .delete(site.siteId)
            .then(() => {
            site.whenDeleted = new Date();
            Notifier.onOk();
            this.$emit("onSiteArchived");
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    restore(site) {
        if (this.working)
            return;
        this.working = true;
        siteClient
            .restore(site.siteId)
            .then(() => {
            site.whenDeleted = undefined;
            Notifier.onOk();
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    reload() {
        this.search();
    }
    ;
    // computed
    get canSearch() {
        return this.companyId ? true : false;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", Number)
], CompanySitesVue.prototype, "companyId", void 0);
__decorate([
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanySitesVue.prototype, "search", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanySitesVue.prototype, "onSortChanged", null);
CompanySitesVue = __decorate([
    Component({
        name: "CompanySitesVue",
        emits: ["onSiteArchived"],
        expose: ["reload"],
    })
], CompanySitesVue);
export default CompanySitesVue;
